module.exports = __webpack_public_path__ + "img/CM-MC-26-CJDR-Modern.0c213cea.jpg";